import { render, staticRenderFns } from "./sweepstakesList.vue?vue&type=template&id=10200130&scoped=true&"
import script from "./sweepstakesList.vue?vue&type=script&lang=js&"
export * from "./sweepstakesList.vue?vue&type=script&lang=js&"
import style0 from "./sweepstakesList.vue?vue&type=style&index=0&id=10200130&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10200130",
  null
  
)

component.options.__file = "sweepstakesList.vue"
export default component.exports